import * as z from "zod";

export const markWithdrawalCompleted = {
  name: "markWithdrawalCompleted" as const,
  input: z.object({ withdrawalId: z.string() }),
  output: z.null(),
};
